import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router
} from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {
    const loginFlag = localStorage.getItem('loginFlag') === 'true';

    if (loginFlag) {
      return true;
    } else {
      // Redirect to home or login
      return this.router.parseUrl('/home');
    }
  }
}
